import React from 'react';
import styled from 'styled-components';
import GroupMemberList from '../component/members/GroupMemberList';
import GroupMemberTopBar from '../component/members/GroupMemberTopBar';
import { useShortCut } from '../shared/hooks/useShortCut';

const Members: React.FC = () => {
  const { handleCmdE } = useShortCut();

  return (
    <MembersContainer
      onKeyDown={(e) => {
        handleCmdE(e);
      }}
      tabIndex={-1}
    >
      <GroupMemberTopBar />
      <GroupMemberList />
    </MembersContainer>
  );
}

export default Members;

const MembersContainer = styled.main`
  width: 93%;
  height: 100vh;
  display: flex;
  flex-direction: column;

  margin-bottom: 3vh;
  overflow: hidden;
`;
